module.exports = __webpack_public_path__ + "media/images/payment/logo_diners-be51fb4722969523ba3b8d5463ae8a3e.gif";